import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Shield, Lock, Mail } from 'lucide-react'
import toast from 'react-hot-toast'

const AdminLoginPage = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    
    // Hardcoded admin credentials
    if (formData.email === 'homayoncse@gmail.com' && formData.password === 'Admin@2026##') {
      localStorage.setItem('adminAuth', 'true')
      toast.success('Admin login successful!')
      navigate('/admin/dashboard')
    } else {
      toast.error('Invalid admin credentials')
    }
  }

  return (
    <main data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="28:4" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:28:4" className="pt-20 min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 flex items-center justify-center px-4">
      <div data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="29:6" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:29:6" className="max-w-md w-full">
        <div data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="30:8" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:30:8" className="bg-white rounded-2xl shadow-2xl p-8">
          <div data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="31:10" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:31:10" className="text-center mb-8">
            <div data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="32:12" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:32:12" className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Shield data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="33:14" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:33:14" className="w-10 h-10 text-blue-600" />
            </div>
            <h1 data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="35:12" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:35:12" className="text-3xl font-bold text-gray-900 mb-2">Admin Portal</h1>
            <p data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="36:12" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:36:12" className="text-gray-600">Sign in to access the dashboard</p>
          </div>

          <form data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="39:10" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:39:10" onSubmit={handleSubmit} className="space-y-6">
            <div data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="40:12" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:40:12">
              <label data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="41:14" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:41:14" className="block text-sm font-medium text-gray-700 mb-2">
                Admin Email
              </label>
              <div data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="44:14" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:44:14" className="relative">
                <Mail data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="45:16" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:45:16" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="46:16" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:46:16"
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full h-11 pl-10 pr-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  placeholder="admin@example.com"
                />
              </div>
            </div>

            <div data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="57:12" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:57:12">
              <label data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="58:14" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:58:14" className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <div data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="61:14" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:61:14" className="relative">
                <Lock data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="62:16" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:62:16" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="63:16" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:63:16"
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  required
                  className="w-full h-11 pl-10 pr-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  placeholder="••••••••"
                />
              </div>
            </div>

            <button data-component-path="client/src/pages/admin/AdminLoginPage.jsx" data-component-line="74:12" data-component-id="client/src/pages/admin/AdminLoginPage.jsx:74:12"
              type="submit"
              className="w-full h-11 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-all duration-200 shadow-md hover:shadow-lg"
            >
              Sign In to Admin Panel
            </button>
          </form>
        </div>
      </div>
    </main>
  )
}

export default AdminLoginPage